// extracted by mini-css-extract-plugin
export default {"bodyWrapper":"ResetPassword_bodyWrapper__8uX20","errorMessage":"ResetPassword_errorMessage__GBdnN"};